import { SkeletonBox } from '@/components/skeleton/skeleton-box';
import { Stack } from '@/ui/line/line';

export const ContentItemFormSkeleton = () => {
  return (
    <Stack gap="40px">
      <SkeletonBox height="40px" />
      <SkeletonBox height="200px" />
      <SkeletonBox height="40px" />
      <SkeletonBox height="40px" />
      <SkeletonBox height="40px" />
    </Stack>
  );
};
